import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { paymentApiAsset } from '../constant/payment-assets';
import { InvoiceResponse, PaymentResponseModel, PaymentSession, ProcessTextToPayRequest } from '../store/payment.state';

@Injectable({providedIn: 'root'})

export class PaymentAPIService {
    constructor(private http: HttpClient) { }

    getPaymentSession(encodedString: string) {
        const param = { 'encodedString': encodedString };
        return this.http.get<PaymentSession>(paymentApiAsset.getPaymentSession, { params: param });
    }

    makePayment(paymentRequestModel: ProcessTextToPayRequest) {
        return this.http.post<PaymentResponseModel>(paymentApiAsset.createPayment, paymentRequestModel);
    }

    getInvoiceResponse(encodedString: string) {
        const param = { 'encodedString': encodedString };
        return this.http.get<InvoiceResponse>(paymentApiAsset.getInvoiceResponse, { params: param });
    }

    
}
